import { withStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Anchor from "@material-ui/core/Link";
import InputBase from "@material-ui/core/InputBase";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { Tooltip } from "@material-ui/core";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import PrintIcon from "@mui/icons-material/Print";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
// import SearchIcon from '@mui/icons-material/Search'
// import { IconButton } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@material-ui/core/TextField'
import Grid from '@material-ui/core/Grid'
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// UI Imports
import Toolbar from "@material-ui/core/Toolbar";
import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// App Imports
// import params from "../../../setup/config/params";
import { messageShow } from "../../common/api/actions";
import EmptyMessage from "../../common/EmptyMessage";
import BrandedLoading from "../../common/BrandedLoading";
import Pagination from "../../common/Pagination";
import SectionPaper from "../../common/SectionPaper";
import {
  cancel,
  deliverToggle,
  dispatchToggle,
  paidToggle,
  remove,
  orderacceptedToggle,
} from "../api/actions/mutation";
import { list } from "../api/actions/query";
import routes from "../api/routes";
import { updateSettings } from "../../setting/api/actions/mutation";
import styles from "./styles";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import DriveEtaOutlinedIcon from "@mui/icons-material/DriveEtaOutlined";
import dayjs from 'dayjs';
import { checkPermission } from "../../common/Sidebar/checkPermission";

// Component
class List extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      orders: [],
      count: 0,
      page: props.match.params.page || 1,
      search: "",
      datesearch: "",
      idsearch: "",
      mobilesearch: "",
      settingsData: null,
      taxAmount: "",
      currency: "",
      currencydata: "",
      selectedSearchType: "all", 
      isUberDeliveryEnabled: "",
      permissions: {
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      },
    };

    this.changeSearch = debounce(this.refresh, 100);
    this.settingsId = window.localStorage.getItem("user")
      ? JSON.parse(window.localStorage.getItem("user")).settingsId
      : null;
  }

  componentDidMount() {
    this.refresh();
    this.verifyPermissions();
  }
  verifyPermissions = async () => {
    const modulePermission = await checkPermission("store", "orders.orderHistory");
    this.setState({permissions:{canEdit:modulePermission.canEdit,canDelete: modulePermission.canDelete,canCreate: modulePermission.canCreate,canView: modulePermission.canView}});
  };
  componentDidUpdate(prevProps) {
    const { match } = this.props;

    if (prevProps.match.params.page !== match.params.page) {
      this.setState({ page: match.params.page }, this.refresh); 
    }
  }
  updateOrderState = (orderId, changes) => {
    this.setState((prevState) => ({
      orders: prevState.orders.map((order) =>
        order._id === orderId ? { ...order, ...changes } : order
      ),
    }));
  };


  refresh = async (isLoading = true) => {
    const { list, messageShow } = this.props;
    const { page, search, datesearch, idsearch, mobilesearch, selectedSearchType } = this.state;
    // Trim whitespace from search fields
    const trimmedSearch = search.trim();
    const trimmedIdSearch = idsearch.trim();
    const trimmedMobileSearch = mobilesearch.trim();

    this.isLoadingToggle(isLoading);

    try {
      const filters = {
        page,
        filter: {
          search: selectedSearchType === "search" ? trimmedSearch : "",
          datesearch: selectedSearchType === "datesearch" ? datesearch : "",
          idsearch: selectedSearchType === "idsearch" ? trimmedIdSearch : "",
          mobilesearch: selectedSearchType === "mobilesearch" ? trimmedMobileSearch : "",
        },
      };
      const { data } = await list(filters);
      if (data.success) {
        const orders = data.data.list;
        let currencySymbol = data.data.currencydata.symbol;
        let isUberDeliveryEnabled = data.data.settingsData.isUberDeliveryEnabled;
        var productTotalPrice = orders.map((order) => order.amountTotal);
        productTotalPrice = Number.parseFloat(productTotalPrice);
        let taxpercentage = data.data.settingsData.taxAmount;
        const taxCalculatedAmount = Number.parseFloat(
          (productTotalPrice / 100) * taxpercentage
        ).toFixed(2);
        const grandTotal = Number(
          Number.parseFloat(
            productTotalPrice + parseFloat(taxCalculatedAmount)
          ).toFixed(2)
        );
        // Push grandTotal as new amountTotal for each order
        const updatedOrders = orders.map((order) => ({
          ...order,
          //amountTotal: grandTotal,
        }));
  
        this.setState({
          orders: updatedOrders,
          count: data.data.count,
          settingsData: data.data.settingsData,
          currencySymbol: currencySymbol,
          isUberDeliveryEnabled: isUberDeliveryEnabled
        });
      } else {
        messageShow(data.message);
      }
    } catch (error) {
      messageShow(error.message);
    } finally {
      this.isLoadingToggle(false);
    }
  };
  isLoadingToggle = (isLoading) => {
    this.setState({
      isLoading,
    });
  };

  onOrderacceptedToggle = (orderId) => async (event) => {
    const isOrderAccepted = event.target.checked;

    let check = window.confirm(
      `Are you sure you want to mark this order as ${
        isOrderAccepted ? "accepted" : "not accepted"
      }?`
    );

    if (check) {
      const { orderacceptedToggle, messageShow, match } = this.props;

      try {
        const { data } = await orderacceptedToggle({
          orderId,
          isOrderAccepted,
        });

        messageShow(data.message);

        if (data.success) {
          this.updateOrderState(orderId, { isOrderAccepted: true });
        }
      } catch (error) {
        messageShow(error.message); 
      }
    }
  };

  onDeliverToggle = (orderId) => async (event) => {
    const isDelivered = event.target.checked;

    let check = window.confirm(
      `Are you sure you want to mark this order as ${
        isDelivered ? "delivered" : "not delivered"
      }?`
    );

    if (check) {
      const { deliverToggle, messageShow, match } = this.props;

      try {
        const { data } = await deliverToggle({ orderId, isDelivered });

        messageShow(data.message);

        if (data.success) {
          this.updateOrderState(orderId, { isDelivered: true });
        }
      } catch (error) {
        messageShow(error.message); 
      }
    }
  };

  onDispatchToggle = (orderId) => async (event) => {
    const isDispatched = event.target.checked;

    let check = window.confirm(
      `Are you sure you want to mark this order as ${
        isDispatched ? "Dispatched" : "not Dispatched"
      }?`
    );

    if (check) {
      const { dispatchToggle, messageShow, match } = this.props;

      try {
        const { data } = await dispatchToggle({ orderId, isDispatched });

        messageShow(data.message);

        if (data.success) {
          this.updateOrderState(orderId, { isDispatched: true });
        }
      } catch (error) {
        messageShow("errorrrrrrrrr", error.message); 
      }
    }
  };

  onPaidToggle = (orderId) => async (event) => {
    const isPaid = event.target.checked;

    let check = window.confirm(
      `Are you sure you want to mark this order as ${
        isPaid ? "paid" : "unpaid"
      }?`
    );

    if (check) {
      const { paidToggle, messageShow, match } = this.props;

      try {
        const { data } = await paidToggle({ orderId, isPaid });
        messageShow(data.message);

        if (data.success) {
          this.updateOrderState(orderId, {
            paymentId: { ...this.state.orders.find(order => order._id === orderId).paymentId, status: isPaid ? "done" : "" }
          });
        }
      } catch (error) {
        messageShow(error.message); 
      }
    }
  };

  onCancel = (orderId) => async () => {
    let check = window.confirm("Are you sure you want to cancel this order?");

    if (check) {
      const { cancel, messageShow, match } = this.props;

      try {
        const { data } = await cancel({ orderId });

        messageShow(data.message);

        if (data.success) {
          this.updateOrderState(orderId, { isCancelled: true });
        }
      } catch (error) {
        messageShow(error.message); 
      }
    }
  };

  onDelete = (orderId) => async () => {
    let check = window.confirm("Are you sure you want to delete this order?");

    if (check) {
      const { remove, messageShow, match } = this.props;

      try {
        const { data } = await remove({ orderId });

        messageShow(data.message);

        if (data.success) {
          this.setState((prevState) => ({
            orders: prevState.orders.filter((order) => order._id !== orderId),
          }));
        }
      } catch (error) {
        messageShow("Some error occurred. Please try again.");
      }
    }
  };

   onSearch = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      if (value.trim() === "") {
        // Clear search input and navigate back to page 1
        this.setState({ page: 1 }, () => {
          this.props.history.push(routes.orderList.path(1)); 
          this.refresh();
        });
      }
      })
    }
            
    handleSearch = () => {
      this.handleSearchSubmit(this.state);  
    };
    handleSearchSubmit = (state) => {
      this.refresh();
    };
    handleDateChange = (date) => {
      const formattedDate = date ? dayjs(date).format('YYYY-MM-DD') : '';
      this.setState({ datesearch: formattedDate }, () => {
        if (formattedDate === '') {
          this.props.history.push(routes.orderList.path(1)); 
          this.refresh();
        }
      });
    };
    
    onSearchTypeChange = (event) => {
      const value = event.target.value;
      const areFieldsCleared = !this.state.search && !this.state.datesearch && !this.state.idsearch && !this.state.mobilesearch;
    
      this.setState(
        {
          selectedSearchType: value,
          search: "",       
          datesearch: "",   
          idsearch: "",     
          mobilesearch: "", 
          page: 1           
        },
        () => {
          // Only refresh if fields were not cleared
          if (!areFieldsCleared || value === "all") {
            this.props.history.push(routes.orderList.path(1)); 
            this.refresh(); 
          }
        }
      );
    };
    
  isSearchValid = () => {
    const { selectedSearchType, search, datesearch, idsearch, mobilesearch } = this.state;

    switch (selectedSearchType) {
      case "search":
        return search.trim() !== ""; 
      case "datesearch":
        return datesearch.trim() !== ""; 
      case "idsearch":
        return idsearch.trim() !== ""; 
      case "mobilesearch":
        return mobilesearch.trim() !== ""; 
      default:
        return false; 
    }
  };


  render() {
    const {
      classes,
    } = this.props;
    const {
      isLoading,
      orders,
      count,
      datesearch,
      currencySymbol,
      selectedSearchType,
      isUberDeliveryEnabled,
      permissions
    } = this.state;
    const isInputDisabled = selectedSearchType === "" || selectedSearchType === "all";
    return (
      <div>
        <Toolbar className={classes.toolbar}>
        <Grid container spacing={2} alignItems="center">
        <Grid item>
          <FormControl variant="outlined" style={{ minWidth: 150 }}>
            <InputLabel id="search-type-label">Search By</InputLabel>
            <Select
              labelId="search-type-label"
              value={selectedSearchType}
              onChange={this.onSearchTypeChange}
              label="Search By"
            >
              <MenuItem value="all">All</MenuItem> 
              <MenuItem value="idsearch">Order ID</MenuItem>
              <MenuItem value="search">Name</MenuItem>
              <MenuItem value="mobilesearch">Mobile</MenuItem>
              <MenuItem value="datesearch">Date</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid item>
          {selectedSearchType === "datesearch" ? (
              <DatePicker
                value={datesearch ? dayjs(datesearch) : null}
                onChange={this.handleDateChange}
                slotProps={{ textField: { variant: "standard", sx: { "& .MuiInput-underline:before": { borderBottomColor: "black" }, "& .MuiInput-underline:after": { borderBottomColor: "blue" } } } }}
                renderInput={(params) => (
                  <InputBase
                    {...params}
                    label="Select Date"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <CalendarTodayIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
          ) : (
            <TextField
              name={selectedSearchType}
              value={this.state[selectedSearchType] || ""}
              placeholder="Search..."
              onChange={this.onSearch}
              disabled={isInputDisabled}
            />
          )}
        </Grid>

          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              onClick={this.handleSearch}
              disabled={isInputDisabled || !this.isSearchValid() }
              style={{ borderRadius: '5px',
                textTransform: 'none',  
                padding: '2px 13px',     
                fontSize: '0.9rem', 
                }}
            >
              Search
            </Button>
          </Grid>
      </Grid>
          
          <div className="d-flex flex-row gap-2">
            <Button id="refreshOrder" onClick={this.refresh}>
              Refresh
            </Button>
          </div>
        </Toolbar>

        <SectionPaper>
          {isLoading ? (
            <BrandedLoading />
          ) : orders.length === 0 ? (
            <EmptyMessage message={"No orders have been placed yet."} />
          ) : (
            <div style={{ maxHeight: window.innerWidth <= 720 ? "auto" : "auto", overflowY: "auto",scrollbarWidth: "none",msOverflowStyle: "none", overflowX: "auto" }}>
              <Table padding={"normal"}>
              <TableHead style={{ position: "sticky", top: 0,background: "white", zIndex: 2 }}>
              <TableRow>
                    {/* <TableCell width={40} align="center"></TableCell> */}
                    <TableCell width={80}>Order ID</TableCell>
                    <TableCell width={80}>Name</TableCell>
                    {/* <TableCell width={80}>Mobile</TableCell> */}
                    <TableCell width={80}>Amount</TableCell>
                    <TableCell width={130}>Date</TableCell>
                    {/*<TableCell width={120}>Payment Type</TableCell>*/}
                    {/*<TableCell width={80}>Pincode</TableCell>*/}

                    <TableCell width={40} align="center">
                      Accepted
                    </TableCell>
                    <TableCell width={40} align="center">
                      Paid
                    </TableCell>
                    <TableCell width={40} align="center">
                      Dispatched
                    </TableCell>
                    <TableCell width={40} align="center">
                      Delivered
                    </TableCell>

                    {/* <TableCell width={90} align="center">Cancel</TableCell> */}
                    <TableCell width={250} align="center">
                      Actions
                    </TableCell>
                    {/* <TableCell width={40} align="center">
                      Delete  
                    </TableCell>
                    <TableCell width={40} align="center">
                      Print  
                    </TableCell> */}
                  </TableRow>
                </TableHead>

                <TableBody>
                    {orders.map((order) => {
                        return (
                      <TableRow
                        key={order._id}
                        style={
                          (!order.isOrderAccepted && !order.isCancelled)
                            ? { backgroundColor: "#FECD62" }  
                            : { backgroundColor: "inherit" }   
                        }
                      >
                        {/* <Tooltip
                          title={
                            deliveryMode === "HOME_DELIVERY"
                              ? "Home Delivery"
                              : deliveryMode === "STORE_PICKUP"
                              ? "Store Pickup"
                              : deliveryMode
                          }
                          placement="top"
                        >
                          <TableCell align="center" style={{ color: "gray" }}>
                            {deliveryMode === "HOME_DELIVERY" ? (
                              <DriveEtaOutlinedIcon />
                            ) : deliveryMode === "STORE_PICKUP" ? (
                              <ShoppingBagOutlinedIcon />
                            ) : (
                              deliveryMode
                            )}
                          </TableCell>
                        </Tooltip> */}

                        <TableCell>
                          <Link 
                            to={{
                              pathname: routes.orderDetail.path(order._id),
                              state: { order: order, currencySymbol}
                            }}
                          >
                            <Anchor
                              component="span"
                              style={{ fontWeight: 500 }}
                              color={order.isCancelled ? "error" : "primary"}
                            >
                              {order.id.toUpperCase()}
                            </Anchor>
                          </Link>
                        </TableCell>
                        <TableCell>{[order.userId?.name]}</TableCell>
                        {/* <TableCell>{[order.userId?.mobile]}</TableCell> */}
                        <TableCell>
                          {currencySymbol} {order.grandTotal}
                        </TableCell>
                        <TableCell>
                         {dayjs(order.createdAt).format('DD-MM-YYYY, hh:mm A')}
                        </TableCell>
                        {/*<TableCell>{params.order.types[type].title}</TableCell>*/}
                        {/*<TableCell>{params.payment.types[paymentId.type] && params.payment.types[paymentId.type].title}</TableCell>*/}
                        {/*<TableCell>{order.pincodeId ? order.pincodeId.pincode : ''}</TableCell>*/}

                        <TableCell align="center">
                          <Checkbox
                            checked={order.isOrderAccepted}
                            onChange={this.onOrderacceptedToggle(order._id)}
                            color="primary"
                            disabled={order.isCancelled || order.isOrderAccepted || !permissions.canEdit}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            checked={order.paymentId.status === "done"}
                            onChange={this.onPaidToggle(order._id)}
                            color="secondary"
                            disabled={
                              order.paymentId.status === "done" ||
                              order.isDelivered ||
                              order.isCancelled ||
                              !permissions.canEdit
                            }
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            disabled={
                              order.isCancelled || !order.isOrderAccepted || order.isDispatched || order.deliveryMode === "STORE_PICKUP" || !permissions.canEdit
                            }
                            checked={order.isDispatched}
                            onChange={this.onDispatchToggle(order._id)}
                            color="primary"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Checkbox
                            disabled={
                              order.isCancelled ||
                              !order.isOrderAccepted ||
                              order.paymentId.status !== "done" ||
                              (order.deliveryMode === "STORE_PICKUP" ? false : !order.isDispatched) ||
                              order.isDelivered ||
                              !permissions.canEdit
                            }
                            checked={order.isDelivered}
                            onChange={this.onDeliverToggle(order._id)}
                            color="primary"
                          />
                        </TableCell>

                        <TableCell>
                          <Tooltip title="Cancel Order" disableHoverListener= {permissions.canDelete ? false : true}>
                            <span>
                              <Button
                                disabled={order.isCancelled || order.isOrderAccepted || !permissions.canDelete}
                                onClick={this.onCancel(order._id)}
                                color="secondary"
                              >
                                <CancelIcon />
                              </Button>
                            </span>
                          </Tooltip>

                          <Tooltip title="Delete order" disableHoverListener= {permissions.canDelete ? false : true}>
                            <span>
                              <Button disabled={order.paymentId.status === "done" || !permissions.canDelete} onClick={this.onDelete(order._id)}>
                                <DeleteIcon style={{ color: "gray" }} />
                              </Button>
                            </span>
                          </Tooltip>
                          
                          {/*<Tooltip title="Uber Delivery">
                            <Link to={`/uberDelivery/${_id}`}>
                              <Button style={{ color: "gray" }}>
                                <LocalShippingIcon />
                              </Button>
                            </Link>
                          </Tooltip>*/}
                          {permissions.canEdit ? (
                            isUberDeliveryEnabled && (
                              <Tooltip title="Uber Delivery">
                                <Link to={`/uberDelivery/${order._id}`}>
                                  <Button style={{ color: "gray" }}>
                                    <LocalShippingIcon />
                                  </Button>
                                </Link>
                              </Tooltip>
                            )
                          ) : (
                            isUberDeliveryEnabled && (
                              <Button style={{ color: "gray" }} disabled>
                                <LocalShippingIcon />
                              </Button>
                            )
                          )}
                          {permissions.canEdit ? (
                            <Link to={routes.orderPrint.path(order._id)}>
                              <Button style={{ color: "gray" }}>
                                <PrintIcon />
                              </Button>
                            </Link>
                          ) : (
                            <Button style={{ color: "gray" }} disabled>
                              <PrintIcon />
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    )
                   })}
                </TableBody>
              
              </Table>
              <Pagination count={count} route={routes.orderSearch} />
              </div>
          )}
        </SectionPaper>
      </div>
    );
  }
}

// Component Properties
List.propTypes = {
  list: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  deliverToggle: PropTypes.func.isRequired,
  dispatchToggle: PropTypes.func.isRequired,
  orderacceptedToggle: PropTypes.func.isRequired,
  paidToggle: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  updateSettings: PropTypes.func.isRequired,
};
// Component State
function listState(state) {
  return {
    auth: state.auth,
  };
}

export default connect(listState, {
  list,
  cancel,
  remove,
  deliverToggle,
  dispatchToggle,
  orderacceptedToggle,
  paidToggle,
  messageShow,
  updateSettings,
})(withStyles(styles)(List));


